import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import {
  FormComponent,
  FormJob,
  clearTypeOperationData,
  FormVehicle,
  fetchAdsRepublish,
  setDistrictFullData,
  setBrandVehicleSelected,
  setModelVehicleSelected,
  setJobSelected
} from '@app/src/views/StepOne/form';
import {
  setPrintGeneral,
  cleanPrintGeneral,
} from '@app/src/views/StepTwo/channelPublication';
import { CATEGORIES, CATEGORY_ALIAS } from '@app/src/config/categories';
import { setUserPasarella } from '@app/src/common/session';
import { clearMyPackageAvailableAll, fetchMyPackageAvailable } from '@app/src/common/CounterAvailable';
import { change } from 'redux-form';

const isClient = isClientEnv();

export const StepOne: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { uniqueId, packageId } = useParams();

  const printStorage = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];
  const categoryId = categoryConfig && categoryConfig.id;
  const urlPrint = categoryConfig.paths.purchasePrint.stepOne;
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const printRepublish = useSelector(state => state.adsRepublish.data);
  const packageConsume = useSelector(state => state.package.dataConsume);
  const typeUserAction = useSelector(state => state.session.user.pasarella);

  useEffect(() => {
    if (typeUserAction === 'consume-print' && packageConsume && Object.keys(packageConsume).length === 0) {
      dispatch(fetchMyPackageAvailable(userStorage && userStorage.data && userStorage.data.id, categoryConfig && categoryConfig.id, packageId));
    }
  }, [packageConsume, typeUserAction]);

  useEffect(() => {
    if (printRepublish && Object.keys(printRepublish).length > 0) {
      const { property_id, vehicle_type_id, employment_id, section_id } = printRepublish;
      const custom = {
        category: Number(categoryId),
        description: printRepublish.description,
        operation: printRepublish.operation_id,
        operationName: printRepublish.operation_name,
        title: printRepublish.title,
      }
      if (property_id) {
        custom['property'] = property_id;
        dispatch(setDistrictFullData(printRepublish.location));
        dispatch(change('stepOne', 'property', printRepublish.property_id));
      }
      if (vehicle_type_id) {
        custom['typeVehicle'] = vehicle_type_id;
        custom['brandVehicleName'] = printRepublish.brand;
        custom['brandAdecsys'] = printRepublish.brand_adecsys;
        custom['modelVehicleName'] = printRepublish.model;
        custom['modelAdecsys'] = printRepublish.model_adecsys;
        custom['yearVehicle'] = printRepublish.year;

        dispatch(setBrandVehicleSelected(printRepublish.brand))
        dispatch(change('stepOne', 'typeVehicle', vehicle_type_id));
        dispatch(change('stepOne', 'brandVehicle', 25));
        dispatch(change('stepOne', 'brandVehicleName', printRepublish.brand));
        dispatch(change('stepOne', 'brandAdecsys', printRepublish.brand_adecsys));
        dispatch(setModelVehicleSelected(printRepublish.model));
        dispatch(change('stepOne', 'modelVehicle', 25));
        dispatch(change('stepOne', 'modelVehicleName', printRepublish.model));
        dispatch(change('stepOne', 'modelAdecsys', printRepublish.model_adecsys));
        dispatch(change('stepOne', 'yearVehicle', printRepublish.year));
      }
      if (employment_id) {
        custom['employment'] = employment_id;
        custom['employmentName'] = printRepublish.employment_name;
        dispatch(setJobSelected(printRepublish.employment_name));
        dispatch(change('stepOne', 'employment', employment_id));
        dispatch(change('stepOne', 'employmentName', printRepublish.employment_name));
      }
      if (section_id) {
        custom['section'] = section_id;
        custom['sectionName'] = printRepublish.section_name;
        dispatch(change('stepOne', 'section', section_id));
        dispatch(change('stepOne', 'sectionName', printRepublish.section_name));

      }

      dispatch(change('stepOne', 'title', printRepublish.title));
      dispatch(change('stepOne', 'category', Number(categoryId)));
      dispatch(change('stepOne', 'operation', printRepublish.operation_id));
      dispatch(change('stepOne', 'operationName', printRepublish.operation_name));
      dispatch(change('stepOne', 'description', printRepublish.description));
      dispatch(setPrintGeneral(custom));
    }
  }, [printRepublish]);

  useEffect(() => {
    let typeAction = 'consume-print';
    if (urlPrint === location.pathname) {
      typeAction = 'purchase-print';
    }
    dispatch(setUserPasarella(typeAction));
    if (typeAction === 'purchase-print') {
      if (printStorage && printStorage.general && categoryConfig && printStorage.general.category === categoryConfig.id) {
        dispatch(setPrintGeneral(printStorage.general));
      } else {
        dispatch(setPrintGeneral({ category: categoryConfig.id }));
      }
    }
    if (typeAction === 'consume-print') {
      if (userStorage && !userStorage.jwt || !userStorage) {
        history.push('/inicia-tu-sesion');
      }
      if (uniqueId) {
        dispatch(fetchAdsRepublish(userStorage && userStorage.data && userStorage.data.id, categoryConfig && categoryConfig.id, uniqueId));
        return;
      }
      if (printStorage && printStorage.general && categoryConfig && printStorage.general.category === categoryConfig.id) {
        dispatch(setPrintGeneral(printStorage.general));
      } else {
        dispatch(setPrintGeneral({ category: categoryConfig.id }));
      }
    }
    return () => {
      dispatch(clearTypeOperationData());
      dispatch(cleanPrintGeneral());
      dispatch(clearMyPackageAvailableAll());
    }
  }, []);

  return (
    <React.Fragment>
      {
        categoryConfig.alias === CATEGORY_ALIAS.INMUEBLE &&
        <FormComponent />
      }
      {
        (categoryConfig.alias === CATEGORY_ALIAS.EMPLEO || categoryConfig.alias === CATEGORY_ALIAS.OPORTUNIDAD || categoryConfig.alias === CATEGORY_ALIAS.EDUCACION) &&
        <FormJob />
      }
      {
        categoryConfig.alias === CATEGORY_ALIAS.VEHICULO &&
        <FormVehicle />
      }
      <ModalErrorFeature />
    </React.Fragment>
  )
};
